// extracted by mini-css-extract-plugin
export default {"wrapper":"Skeleton_wrapper__1HVdh","shimmer":"Skeleton_shimmer__6lnqh"};